
const enum MarketOperation {
  'Cancelled',
  'TakesPlace',
  'Before',
  'After'

};

const enum Weekday {
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'

};
import { Marketplace, Contact } from './';
import { Branch } from './';
import {JsonProperty, deserialize} from 'json-typescript-mapper';
export class Marketday {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: string;

  @JsonProperty('active')
  public active?: boolean;

  @JsonProperty('name')
  public name?: string;

  @JsonProperty('keyword')
  public keyword?: string;

  @JsonProperty('marketType')
  public marketType?: string;

  @JsonProperty('assortment')
  public assortment?: string;

  @JsonProperty('vatType')
  public vatType?: string;

  @JsonProperty('unit')
  public unit?: string;

  @JsonProperty('classification')
  public classification?: string;

  @JsonProperty('onHolidayString')
  public onHolidayString?: string;

  @JsonProperty('onHoliday')
  public onHoliday?: MarketOperation;

  @JsonProperty('dayString')
  public dayString?: string;

  @JsonProperty('day')
  public day?: Weekday;

  @JsonProperty('startTime')
  public startTime?: string;

  @JsonProperty('endTime')
  public endTime?: string;

  @JsonProperty('buildingStartTime')
  public buildingStartTime?: string;

  @JsonProperty('dismantlingEndTime')
  public dismantlingEndTime?: string;

  @JsonProperty('startTimeWinter')
  public startTimeWinter?: string;

  @JsonProperty('endTimeWinter')
  public endTimeWinter?: string;

  @JsonProperty('buildingStartTimeWinter')
  public buildingStartTimeWinter?: string;

  @JsonProperty('dismantlingEndTimeWinter')
  public dismantlingEndTimeWinter?: string;

  @JsonProperty('marketplaceNumber')
  public marketplaceNumber?: string;

  @JsonProperty('branchString')
  public branchString?: string;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty('gguid')
  public gguid?: string;

  @JsonProperty({clazz: Marketplace, name: 'marketplace', customConverter: {
    fromJson: (data: any) => {
      return deserialize<Marketplace>(Marketplace, data);
    },
    toJson: (data: any) => {return data; }
  }})
  public marketplace?: Marketplace;

  @JsonProperty({clazz: Branch, name: 'branch'})
  public branch?: Branch;

  @JsonProperty({clazz: Contact, name: 'marketMaster1'})
  public marketMaster1?: Contact;

  @JsonProperty({clazz: Contact, name: 'marketMaster2'})
  public marketMaster2?: Contact;

  @JsonProperty({clazz: Contact, name: 'marketMaster3'})
  public marketMaster3?: Contact;

  @JsonProperty('limitations')
  public limitations?: string;

  @JsonProperty('priceCategoryTitleA')
  public priceCategoryTitleA?: string;

  @JsonProperty('priceCategoryTitleB')
  public priceCategoryTitleB?: string;

  @JsonProperty('priceCategoryTitleC')
  public priceCategoryTitleC?: string;

  @JsonProperty('priceCategoryTitleD')
  public priceCategoryTitleD?: string;

  @JsonProperty('mm1Percentage')
  public mm1Percentage?: number;

  @JsonProperty('mm2Percentage')
  public mm2Percentage?: number;

  @JsonProperty('mm3Percentage')
  public mm3Percentage?: number;

  @JsonProperty('notInWeb')
  public notInWeb?: boolean;

  @JsonProperty('marketwebsiteSince')
  public marketwebsiteSince?: string;

  @JsonProperty('openingDurationSummer')
  public openingDurationSummer?: number;

  @JsonProperty('openingDurationWinter')
  public openingDurationWinter?: number;

  constructor(input?: any) {
    this.id = void 0;
    this.marketdayNumber = void 0;
    this.name = void 0;
    this.keyword = void 0;
    this.marketType = void 0;
    this.assortment = void 0;
    this.vatType = void 0;
    this.unit = void 0;
    this.classification = void 0;
    this.onHolidayString = void 0;
    this.onHoliday = void 0;
    this.dayString = void 0;
    this.day = void 0;
    this.startTime = void 0;
    this.endTime = void 0;
    this.buildingStartTime = void 0;
    this.dismantlingEndTime = void 0;
    this.startTimeWinter = void 0;
    this.endTimeWinter = void 0;
    this.buildingStartTimeWinter = void 0;
    this.dismantlingEndTimeWinter = void 0;
    this.marketplaceNumber = void 0;
    this.branchString = void 0;
    this.updated = void 0;
    this.created = void 0;
    this.gguid = void 0;
    this.marketplace = void 0;
    this.branch = void 0;
    this.marketMaster1 = void 0;
    this.marketMaster2 = void 0;
    this.marketMaster3 = void 0;
    this.active = false;
    this.limitations = void 0;
    this.priceCategoryTitleA = void 0;
    this.priceCategoryTitleB = void 0;
    this.priceCategoryTitleC = void 0;
    this.priceCategoryTitleD = void 0;
    this.mm1Percentage = void 0;
    this.mm2Percentage = void 0;
    this.mm3Percentage = void 0;
    this.notInWeb = void 0;
    this.marketwebsiteSince = void 0;
    this.openingDurationSummer = void 0;
    this.openingDurationWinter = void 0;

    if (input) {
      Object.assign(this, input);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/marketday.model.ts